{
  "hero": {
    "title": "Haz oro como si <em>fuera tu trabajo.<br/></em>",
    "subtitle": "Inteligencia de flipping entre reinos para la casa de subastas de Retail. Datos en vivo, presentados como las ofertas que de verdad debes tomar — no otro gráfico para leer.",
    "ctaPrimary": "Empieza una prueba gratis",
    "ctaSecondary": "Verlo en acción",
    "stats": {
      "regions": "Regiones",
      "regionsValue": "EU · US",
      "updated": "Actualización",
      "updatedValue": "Cada hora"
    }
  },
  "toolsSection": {
    "label": "Herramientas",
    "sectionTitle": "Seis herramientas. Un objetivo: oro.",
    "watchDemo": "Ver demo",
    "tags": {
      "flippingTool": "Entre reinos",
      "dropshipTool": "Mercados vacíos",
      "realmStats": "Datos",
      "tsmListGenerator": "Exportar TSM",
      "snipeAlerts": "Tiempo real",
      "inventoryAnalysis": "Escaneo de bolsa"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Herramienta de Flipping",
      "description": "Herramienta de flipping entre reinos que analiza las mejores ofertas para un objeto.",
      "videoTitle": "Herramienta de Flipping Entre Reinos",
      "features": {
        "0": "Encuentra la mejor oferta para un objeto basándote en datos en vivo.",
        "1": "Selecciona reinos específicos en los que quieres comprar y vender.",
        "2": "Muestra el beneficio en oro entre reino de compra y de venta.",
        "3": "Calcula el % de beneficio para promedio de venta vs. compra y venta vs. compra.",
        "4": "Muestra exactamente en qué reino/clúster de reinos comprar y en cuál vender.",
        "5": "Filtros/ordenación para distintos tipos de objetos y estadísticas de precio"
      }
    },
    "dropshipTool": {
      "title": "Herramienta de Dropship",
      "description": "Herramienta de dropship que muestra qué objetos no están listados en un servidor para que puedas hacer flip sin competencia.",
      "videoTitle": "Herramienta de Dropship",
      "features": {
        "0": "Encuentra el mejor servidor para vender sin competencia",
        "1": "Selecciona reinos específicos en los que quieres comprar y vender.",
        "2": "Muestra el beneficio en oro entre reino de compra y de venta.",
        "3": "Calcula el % de beneficio para promedio de venta vs. compra y venta vs. compra.",
        "4": "Muestra exactamente en qué reino/clúster de reinos comprar y en cuál vender.",
        "5": "Filtros/ordenación para distintos tipos de objetos y estadísticas de precio"
      }
    },
    "realmStats": {
      "title": "Estadísticas de Reino",
      "description": "Información estadística sobre cada reino, precios e información de subastas. Esto puede ayudarte a decidir dónde comprar y dónde vender.",
      "videoTitle": "Estadísticas de Reino",
      "features": {
        "0": "Encuentra información de precios sobre cada reino",
        "1": "Observa qué servidores venden caro o barato"
      }
    },
    "tsmListGenerator": {
      "title": "Generador de Listas TSM",
      "description": "Herramienta avanzada de generación de listas TSM para crear listas de objetos personalizadas basadas en datos.",
      "videoTitle": "Generador de Listas TSM",
      "features": {
        "0": "Usa múltiples fuentes de precios para filtrar los mejores objetos",
        "1": "Crea la lista TSM perfecta basándote en una amplia gama de datos.",
        "2": "Exporta tu lista TSM personalizada con 1 clic."
      }
    },
    "snipeAlerts": {
      "title": "Alertas de Snipe",
      "description": "Recibe una notificación en el momento en que aparezcan objetos infravalorados, mascotas o BoEs de ilvl en la casa de subastas — antes de que nadie pueda llevárselos.",
      "videoTitle": "Vista previa de alertas de snipe",
      "features": {
        "0": "Monitoriza objetos, mascotas de combate y BoEs ilvl por debajo de tu precio objetivo.",
        "1": "Recibe DMs o webhooks instantáneos en Discord cuando se encuentre un snipe.",
        "2": "Configura umbrales por objeto con una interfaz simple y clara."
      }
    },
    "inventoryAnalysis": {
      "title": "Análisis de Inventario",
      "description": "Pega el CSV de inventario de tu addon FlipQueue para ver al instante qué objetos merece la pena flipear entre reinos. Usa el resultado en el addon para listar en los mejores servidores.",
      "videoTitle": "Análisis de Inventario",
      "features": {
        "0": "Analiza tu inventario actual contra precios en vivo entre reinos.",
        "1": "Detecta al instante qué objetos en tu bolsa son rentables para flipear."
      }
    }
  },
  "edge": {
    "label": "La ventaja",
    "sectionTitle": "Por qué los miembros mantienen su suscripción.",
    "items": {
      "0": {
        "title": "Más oro.",
        "body": "Mostramos los flips con mayor margen por minuto de esfuerzo. Tu oro-por-hora es la cifra que optimizamos."
      },
      "1": {
        "title": "Recupera tus tardes.",
        "body": "Horas de escaneos TSM colapsan en una interfaz consultable. Filtra, ordena, exporta una lista TSM, listo."
      },
      "2": {
        "title": "Empieza esta noche.",
        "body": "Sin hojas de cálculo ni addons pesados. La mayoría de miembros hace su primer flip rentable el primer día."
      }
    }
  },
  "reviews": {
    "label": "Reseñas",
    "sectionTitle": "Lo que dicen nuestros miembros.",
    "videoTitle": "Reseñas de miembros de FlippingPal"
  },
  "pricing": {
    "label": "Membresía",
    "sectionTitle": "Una suscripción. Todas las herramientas.",
    "subtitle": "La suscripción da acceso a todas las herramientas de Flipping Pal"
  },
  "faq": {
    "label": "Preguntas",
    "sectionTitle": "Preguntas frecuentes.",
    "items": {
      "0": {
        "question": "¿Tengo acceso a todas las herramientas con la suscripción mensual?",
        "answer": "Sí, tendrás acceso completo a todas las herramientas de Flipping Pal."
      },
      "1": {
        "question": "¿En qué región de WoW funciona?",
        "answer": "Tanto en US (NA) como en EU (Europa)."
      },
      "2": {
        "question": "¿Puedo cancelar mi suscripción en cualquier momento?",
        "answer": "Sí, puedes cancelar tu suscripción en cualquier momento. Una vez cancelada, perderás el acceso a las herramientas."
      },
      "3": {
        "question": "¿Qué métodos de pago se aceptan?",
        "answer": "Cualquier tarjeta de débito/crédito."
      },
      "4": {
        "question": "Si tengo alguna pregunta, ¿recibiré ayuda?",
        "answer": "Sí, si tienes preguntas contacta al equipo en Discord."
      }
    }
  },
  "modal": {
    "close": "Cerrar"
  },
  "backToTop": "Volver arriba",
  "footerCta": {
    "joinAsAffiliate": "Únete como afiliado",
    "contactUs": "Contáctanos",
    "discord": "Discord",
    "refundPolicy": "Política de reembolso",
    "privacyPolicy": "Política de privacidad",
    "termsAndConditions": "Términos y condiciones",
    "copyright": "© 2026 Flipping Pal - Todos los derechos reservados. Por",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
